<template>
  <div class="">
    <label
      class="relative w-full flex justify-center items-center p-2 sm:p-3 rounded-xl upload_border transition-colors duration-200"
      :class="[
        isUploadDisabled
          ? 'cursor-not-allowed bg-gray-100 border-gray-200'
          : isDragOver
          ? 'cursor-pointer border-cyan-400 bg-cyan-50'
          : 'cursor-pointer border-slate-300 bg-slate-50',
      ]"
      style="box-shadow: 0px 1px 2px 0px #0000000d"
      @dragover.prevent="!isUploadDisabled && handleDragOver"
      @dragleave.prevent="!isUploadDisabled && handleDragLeave"
      @drop.prevent="!isUploadDisabled && handleDrop"
    >
      <HFileUpload :class="isUploadDisabled ? 'text-gray-300' : 'icon-color'" />
      <div class="text-sm leading-snug ml-2.5">
        <p :class="isUploadDisabled ? 'text-gray-400' : 'text-slate-600'">
          <span
            :class="
              isUploadDisabled
                ? 'text-gray-500 font-bold'
                : 'text-cyan-600 font-bold'
            "
          >
            {{
              disabled
                ? "Файл юклаш ўчирилган"
                : isLimitReached
                ? "Файл сони лимитига етди"
                : "Файлни юклаш учун босинг"
            }}
          </span>
          {{ isUploadDisabled ? "" : "ёки уни олиб шу майдонга ташланг" }}
        </p>
        <p v-if="!isUploadDisabled" class="text-slate-400">
          Битта файл ҳажми {{ maxSize / (1024 * 1024) }}МБ дан ошмаслиги керак!
        </p>
      </div>
      <input
        class="hidden"
        type="file"
        ref="file"
        @change="fileUpload"
        :accept="accept"
        :multiple="multiple"
        :disabled="isUploadDisabled"
      />
      <p class="error-p absolute top-full left-0 text-red-500 text-xs mt-px">
        {{ errorMessage }}
      </p>
    </label>
    <!-- Carousel Modal -->
    <div
      v-if="showCarousel"
      class="upload-gallery fixed inset-0 z-50 flex items-center justify-center px-4 py-6 sm:px-6"
      @click.self="closeCarousel"
    >
      <div class="relative flex h-full w-full max-w-6xl flex-col justify-center">
        <div class="upload-gallery__viewer relative overflow-hidden rounded-[2px]">
          <div
            class="flex h-full transition-transform duration-300 ease-in-out"
            :style="{ transform: `translateX(-${carouselIndex * 100}%)` }"
          >
            <div
              v-for="(file, i) in imageFiles"
              :key="`${file.name}-${i}`"
              class="flex h-full w-full flex-shrink-0 items-center justify-center"
            >
              <img
                :src="file.url || file.file"
                class="upload-gallery__image"
                :alt="file.name"
              />
            </div>
          </div>
        </div>

        <button
          @click="closeCarousel"
          type="button"
          class="upload-gallery__close absolute right-4 top-4 flex h-11 w-11 items-center justify-center bg-white text-slate-700 transition hover:bg-slate-100"
          aria-label="Close preview"
        >
          <span class="text-3xl leading-none">&times;</span>
        </button>

        <button
          v-if="imageFiles.length > 1"
          @click="carouselPrev"
          type="button"
          class="upload-gallery__nav absolute bottom-24 right-20 flex h-10 w-10 items-center justify-center bg-white text-slate-700 transition hover:bg-slate-100 sm:bottom-36"
          aria-label="Previous image"
        >
          &#8249;
        </button>

        <button
          v-if="imageFiles.length > 1"
          @click="carouselNext"
          type="button"
          class="upload-gallery__nav absolute bottom-24 right-4 flex h-10 w-10 items-center justify-center bg-white text-slate-700 transition hover:bg-slate-100 sm:bottom-36"
          aria-label="Next image"
        >
          &#8250;
        </button>

        <div
          v-if="imageFiles.length > 1"
          class="upload-gallery__counter absolute bottom-24 right-32 flex h-10 min-w-[72px] items-center justify-center bg-white/95 px-3 text-lg font-semibold text-slate-600 sm:bottom-36"
        >
          {{ carouselIndex + 1 }} / {{ imageFiles.length }}
        </div>

        <div
          v-if="imageFiles.length"
          class="upload-gallery__thumbs mt-4 flex items-center gap-2 overflow-x-auto pb-1 sm:mt-5"
        >
          <button
            v-for="(file, i) in imageFiles"
            :key="`thumb-${file.name}-${i}`"
            type="button"
            class="upload-gallery__thumb relative h-20 w-28 flex-shrink-0 overflow-hidden border-2 transition"
            :class="i === carouselIndex ? 'is-active' : ''"
            @click="goToCarousel(i)"
            :aria-label="`${i + 1}-image`"
          >
            <img
              :src="file.url || file.file"
              :alt="file.name"
              class="h-full w-full object-cover"
            />
          </button>
        </div>
      </div>
    </div>

    <div v-if="value.length" class="mt-2 sm:mt-5">
      <p class="text-sm leading-snug text-slate-500 mb-2.5">
        {{ $t("uploaded_files") }}
      </p>
      <div class="flex flex-col gap-2.5">
        <div v-for="(file, index) in value" :key="index">
          <div
            class="bg-white border border-slate-200 px-3 py-2 rounded-xl flex items-center gap-2"
            style="box-shadow: 0px 1px 2px 0px #0000000d"
          >
            <div @click="()=> isImageFile(file) && openCarousel(file)" :class="{'cursor-pointer':isImageFile(file)}">
              <IconFileDoc
                v-if="file.name.endsWith('.doc') || file.name.endsWith('.docx')"
              />
              <icon-file-pdf v-else-if="file.name.endsWith('.pdf')" />
              <IconFileXls
                v-else-if="
                  file.name.endsWith('.xls') || file.name.endsWith('.xlsx')
                "
              />
              <IconFileSvg v-else-if="file.name.endsWith('.svg')" />
              <IconFilePng v-else-if="file.name.endsWith('.png')" />
              <IconFileJpg
                v-else-if="
                  file.name.endsWith('.jpg') || file.name.endsWith('.jpeg')
                "
                
              />
              <IconFile v-else />
            </div>
            <div class="flex-1 min-w-0">
              <p class="truncate text-slate-950 font-medium leading-snug">
                {{ file.name }}
              </p>
              <p class="text-xs text-slate-400">
                {{
                  file.file.size
                    ? formatFileSize(file.file.size)
                    : `ID: ${file.id}`
                }}
              </p>
            </div>
            <div class="flex items-center gap-1">
              <a
                :href="file.url || file.file"
                target="_blank"
                :download="file.name"
                class="w-10 h-10 rounded-xl flex items-center justify-center bg-indigo-50 text-indigo-800"
              >
                <HFileDownload />
              </a>
              <el-popconfirm
                title="Сиз ушбу файлни ростдан ўчирмоқчимисиз?"
                confirm-button-text="Ҳа"
                cancel-button-text="Йўқ"
                @confirm="!disabled && RemoveFile(index)"
              >
                <button
                  slot="reference"
                  type="button"
                  class="w-10 h-10 rounded-xl flex items-center justify-center"
                  :class="
                    disabled
                      ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      : 'bg-rose-50 text-rose-600 hover:bg-rose-100'
                  "
                  :disabled="disabled"
                >
                  <HTrash />
                </button>
              </el-popconfirm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HFileUpload from "../Icons/hFileUpload.vue";
import HFileDownload from "../Icons/hFileDownload.vue";
import HTrash from "../Icons/hTrash.vue";
import IconFile from "../Icons/iconFile.vue";
import IconFileDoc from "../Icons/iconFileDoc.vue";
import IconFilePdf from "../Icons/iconFilePdf.vue";
import IconFileXls from "../Icons/iconFileXls.vue";
import IconFileSvg from "../Icons/iconFileSvg.vue";
import IconFilePng from "../Icons/iconFilePng.vue";
import IconFileJpg from "../Icons/iconFileJpg.vue";

export default {
  name: "Upload",
  emits: ["input", "change"],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    accept: {
      type: String,
      default: ".xlsx,.xls,.jpg,.png,.jpeg,.doc, .docx,.ppt, .pptx,.txt,.pdf",
    },
    maxSize: {
      type: Number,
      default: 30 * 1024 * 1024, // 30MB in bytes
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    deleteUrl: {
      type: String,
      default: "",
    },
  },
  components: {
    HFileUpload,
    HFileDownload,
    HTrash,
    IconFile,
    IconFileDoc,
    IconFilePdf,
    IconFileXls,
    IconFileSvg,
    IconFilePng,
    IconFileJpg,
  },
  data() {
    return {
      isDragOver: false,
      errorMessage: "",
      showCarousel: false,
      carouselIndex: 0,
    };
  },
  watch: {
    showCarousel(value) {
      if (typeof document === "undefined") return;

      document.body.style.overflow = value ? "hidden" : "";

      if (value) {
        window.addEventListener("keydown", this.handleCarouselKeydown);
        return;
      }

      window.removeEventListener("keydown", this.handleCarouselKeydown);
    },
  },
  beforeDestroy() {
    if (typeof document !== "undefined") {
      document.body.style.overflow = "";
    }

    window.removeEventListener("keydown", this.handleCarouselKeydown);
  },
  computed: {
    isLimitReached() {
      return this.limit && this.value.length >= this.limit;
    },
    isUploadDisabled() {
      return this.disabled || this.isLimitReached;
    },
    imageFiles() {
      const imageExts = ['.jpg', '.jpeg', '.png', '.svg', '.gif', '.webp'];
      return this.value.filter(f =>
        imageExts.some(ext => f.name.toLowerCase().endsWith(ext))
      );
    },
  },
  methods: {
    isImageFile(file) {
      const imageExts = ['.jpg', '.jpeg', '.png', '.svg', '.gif', '.webp'];
      return imageExts.some(ext => file.name.toLowerCase().endsWith(ext));
    },
    openCarousel(file) {
      const idx = this.imageFiles.findIndex(f => f === file);
      this.carouselIndex = idx !== -1 ? idx : 0;
      this.showCarousel = true;
    },
    closeCarousel() {
      this.showCarousel = false;
    },
    goToCarousel(index) {
      this.carouselIndex = index;
    },
    carouselPrev() {
      this.carouselIndex = (this.carouselIndex - 1 + this.imageFiles.length) % this.imageFiles.length;
    },
    carouselNext() {
      this.carouselIndex = (this.carouselIndex + 1) % this.imageFiles.length;
    },
    handleCarouselKeydown(event) {
      if (!this.showCarousel) return;

      if (event.key === "Escape") {
        this.closeCarousel();
        return;
      }

      if (this.imageFiles.length <= 1) return;

      if (event.key === "ArrowLeft") {
        this.carouselPrev();
      }

      if (event.key === "ArrowRight") {
        this.carouselNext();
      }
    },

    fileUpload(event) {
      if (this.isUploadDisabled) return;

      const files = Array.from(event.target.files);
      const validFiles = files.filter((file) => file.size <= this.maxSize);

      if (validFiles.length === 0) {
        this.errorMessage = `Битта файл ҳажми ${
          this.maxSize / (1024 * 1024)
        }МБ дан ошмаслиги керак!`;
        return;
      } else {
        this.errorMessage = "";
        const newFiles = [
          ...this.value,
          ...validFiles.map((file) => ({
            name: file.name,
            url: URL.createObjectURL(file),
            file: file,
          })),
        ];
        this.$emit("input", newFiles);
        this.$emit("change", newFiles);
      }

      // Reset input
      event.target.value = "";
    },

    RemoveFile(index) {
      if (this.disabled) return;
      if (this.deleteUrl && this.value[index].id) {
        if (this.value.length <= this.min) {
          this.$message({
            type: "warning",
            message: `Камида ${this.min} та файл бўлиши керак!`,
          });
          return;
        }
        // If deleteUrl is provided and file has an ID, make a delete request
        axios
          .delete(`${this.deleteUrl}${this.value[index].id}/`)
          .then(() => {
            this.$message.success(this.$t("deleted_success"));
            const updatedFiles = [...this.value];
            updatedFiles.splice(index, 1);
            this.$emit("input", updatedFiles);
            this.$emit("change", updatedFiles);
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: this.$t('deleted_error'),
            });
          });
        return;
      }
      // Update v-model
      const updatedFiles = [...this.value];
      updatedFiles.splice(index, 1);
      this.$emit("input", updatedFiles);
      this.$emit("change", updatedFiles);
    },

    handleDragOver(event) {
      if (this.isUploadDisabled) return;
      event.preventDefault();
      this.isDragOver = true;
    },

    handleDragLeave(event) {
      if (this.isUploadDisabled) return;
      event.preventDefault();
      this.isDragOver = false;
    },

    handleDrop(event) {
      if (this.isUploadDisabled) return;
      event.preventDefault();
      this.isDragOver = false;

      const files = event.dataTransfer.files;
      const validFiles = Array.from(files).filter(
        (file) => file.size <= this.maxSize
      );

      if (validFiles.length === 0) {
        this.errorMessage = `Битта файл ҳажми ${
          this.maxSize / (1024 * 1024)
        }МБ дан ошмаслиги керак!`;
        return;
      } else {
        this.errorMessage = "";
        const newFiles = [
          ...this.value,
          ...validFiles.map((file) => ({
            name: file.name,
            url: URL.createObjectURL(file),
            file: file,
          })),
        ];
        this.$emit("input", newFiles);
        this.$emit("change", newFiles);
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-gallery {
  background: rgba(17, 24, 39, 0.72);
  backdrop-filter: blur(4px);
}

.upload-gallery__viewer {
  height: min(76vh, 760px);
  background: rgba(255, 255, 255, 0.04);
}

.upload-gallery__image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  user-select: none;
}

.upload-gallery__close,
.upload-gallery__nav,
.upload-gallery__counter,
.upload-gallery__thumb {
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

.upload-gallery__nav {
  font-size: 30px;
  line-height: 1;
}

.upload-gallery__thumb {
  opacity: 0.62;
  border-color: transparent;
  background: rgba(255, 255, 255, 0.08);

  &.is-active {
    opacity: 1;
    border-color: #ffffff;
  }
}

.upload-gallery__thumbs::-webkit-scrollbar {
  height: 6px;
}

.upload-gallery__thumbs::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.35);
}

.error-p {
  font-size: 12px;
  font-weight: 500;
}

.drag-over {
  border-color: #06b6d4;
  background-color: #ecfeff;
}
.upload_border {
  border: 1px dashed #cbd5e1;
}
.icon-color {
  color: #cbd5e1;
}
.is-error {
  .upload_border {
    border-color: #f56c6c;
  }
  .icon-color {
    color: #f87171;
  }
}

@media (max-width: 640px) {
  .upload-gallery__viewer {
    height: 58vh;
  }

  .upload-gallery__thumb {
    width: 84px;
    height: 64px;
  }

  .upload-gallery__counter {
    bottom: 90px;
    right: 108px;
    min-width: 64px;
    font-size: 14px;
  }

  .upload-gallery__nav {
    bottom: 90px;
  }
}
</style>
